import React from 'react';
import {ueGradientColors, AccentColorProps} from 'epic-ue-theme';

export const FeaturesVfxIcon = ({accentColor = 'sky'}: AccentColorProps): JSX.Element => {
    const gradient = ueGradientColors[accentColor];
    const {from, to} = gradient;

    return (
        <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path
                    d="M45.5238 77.1499C45.616 77.6944 46.1321 78.0612 46.6766 77.969C47.2212 77.8769 47.5879 77.3607 47.4958 76.8162L42.0916 44.8823L55.7244 67.8222C56.0066 68.297 56.6202 68.4532 57.095 68.171C57.5697 67.8889 57.7259 67.2752 57.4437 66.8005L42.9765 42.4566L70.7676 65.5285C71.1926 65.8813 71.823 65.8228 72.1758 65.3979C72.5286 64.9729 72.4701 64.3425 72.0452 63.9897L47.0434 43.2335L64.0002 49.3996C64.5192 49.5884 65.093 49.3206 65.2817 48.8016C65.4705 48.2825 65.2027 47.7088 64.6837 47.52L44.0036 40H78.9977C79.55 40 79.9977 39.5523 79.9977 39C79.9977 38.4477 79.55 38 78.9977 38H46.098L75.0385 26.1391C75.5495 25.9297 75.794 25.3456 75.5846 24.8346C75.3751 24.3236 74.7911 24.0791 74.28 24.2885L45.0158 36.2821L66.1916 17.6887C66.6066 17.3243 66.6477 16.6924 66.2832 16.2774C65.9189 15.8624 65.287 15.8214 64.872 16.1858L44.5867 33.9973L59.7085 6.58906C59.9753 6.10549 59.7995 5.4972 59.316 5.23041C58.8324 4.96361 58.2241 5.13934 57.9573 5.62291L42.6119 33.4364L45.8404 16.8905C45.9462 16.3484 45.5925 15.8232 45.0504 15.7175C44.5084 15.6117 43.9832 15.9654 43.8774 16.5075L40.3495 34.5882L34.6556 0.942676C34.5635 0.398134 34.0473 0.0313998 33.5028 0.123553C32.9583 0.215706 32.5915 0.731851 32.6837 1.27639L38.3293 34.6367L24.7404 11.7709C24.4583 11.2961 23.8447 11.14 23.3699 11.4221C22.8951 11.7043 22.739 12.3179 23.0211 12.7927L35.3353 33.5135L10.11 12.5718C9.68506 12.219 9.05461 12.2775 8.70183 12.7025C8.34906 13.1274 8.40755 13.7579 8.83249 14.1106L36.9105 37.4207L13.8679 29.0416C13.3488 28.8528 12.7751 29.1206 12.5863 29.6396C12.3976 30.1586 12.6653 30.7324 13.1844 30.9211L32.6512 38H0.756989C0.204704 38 -0.243011 38.4477 -0.243011 39C-0.243011 39.5523 0.204704 40 0.756989 40H35.944L3.07567 53.4706C2.56463 53.6801 2.32014 54.2641 2.52958 54.7752C2.73902 55.2862 3.32308 55.5307 3.83411 55.3213L34.7149 42.6652L17.2724 57.9806C16.8574 58.345 16.8163 58.9768 17.1807 59.3918C17.5451 59.8068 18.177 59.8479 18.592 59.4835L37.3079 43.05L20.5996 73.3338C20.3328 73.8174 20.5085 74.4257 20.9921 74.6925C21.4756 74.9593 22.0839 74.7836 22.3507 74.3L38.2094 45.5561L34.6795 63.647C34.5737 64.1891 34.9274 64.7142 35.4695 64.82C36.0115 64.9258 36.5367 64.5721 36.6425 64.03L40.2097 45.7481L45.5238 77.1499Z"
                    fill="url(#paint0_radial)"
                />
                <path
                    d="M35.056 69.5941C35.1643 69.0525 34.8131 68.5257 34.2715 68.4174C33.73 68.3091 33.2032 68.6603 33.0948 69.2019L32.2895 73.2288C32.1811 73.7704 32.5324 74.2972 33.0739 74.4055C33.6155 74.5138 34.1423 74.1626 34.2506 73.621L35.056 69.5941Z"
                    fill="url(#paint1_radial)"
                />
                <path
                    d="M47.4443 6.1411C47.9859 6.24941 48.3371 6.77623 48.2288 7.31779L47.4234 11.3447C47.3151 11.8863 46.7882 12.2375 46.2467 12.1292C45.7051 12.0209 45.3539 11.4941 45.4622 10.9525L46.2676 6.92556C46.3759 6.384 46.9027 6.03279 47.4443 6.1411Z"
                    fill="url(#paint2_radial)"
                />
                <path
                    d="M73.5217 11.6593C73.9122 11.2687 73.9122 10.6356 73.5217 10.245C73.1311 9.85452 72.498 9.85452 72.1075 10.245L68.7312 13.6213C68.3407 14.0118 68.3407 14.645 68.7312 15.0355C69.1217 15.4261 69.7549 15.4261 70.1454 15.0355L73.5217 11.6593Z"
                    fill="url(#paint3_radial)"
                />
                <path
                    d="M14.8388 62.9402C15.2293 63.3308 15.2293 63.9639 14.8388 64.3545L11.4625 67.7307C11.072 68.1213 10.4388 68.1213 10.0483 67.7307C9.6578 67.3402 9.6578 66.707 10.0483 66.3165L13.4246 62.9402C13.8151 62.5497 14.4483 62.5497 14.8388 62.9402Z"
                    fill="url(#paint4_radial)"
                />
                <path
                    d="M20.1224 6.54376C20.1224 7.53591 19.3181 8.3402 18.3259 8.3402C17.3338 8.3402 16.5295 7.53591 16.5295 6.54376C16.5295 5.55162 17.3338 4.74733 18.3259 4.74733C19.3181 4.74733 20.1224 5.55162 20.1224 6.54376Z"
                    fill="url(#paint5_radial)"
                />
                <path
                    d="M68.0233 76.0057C68.0233 76.9979 67.219 77.8022 66.2269 77.8022C65.2347 77.8022 64.4304 76.9979 64.4304 76.0057C64.4304 75.0136 65.2347 74.2093 66.2269 74.2093C67.219 74.2093 68.0233 75.0136 68.0233 76.0057Z"
                    fill="url(#paint6_radial)"
                />
                <path
                    d="M9.93957 75.407C10.9317 75.407 11.736 74.6027 11.736 73.6106C11.736 72.6184 10.9317 71.8141 9.93957 71.8141C8.94743 71.8141 8.14314 72.6184 8.14314 73.6106C8.14314 74.6027 8.94743 75.407 9.93957 75.407Z"
                    fill="url(#paint7_radial)"
                />
                <path
                    d="M29.7011 77.2035C29.7011 78.1957 28.8968 78.9999 27.9047 78.9999C26.9125 78.9999 26.1082 78.1957 26.1082 77.2035C26.1082 76.2114 26.9125 75.4071 27.9047 75.4071C28.8968 75.4071 29.7011 76.2114 29.7011 77.2035Z"
                    fill="url(#paint8_radial)"
                />
                <path
                    d="M73.4154 56.2451C74.4075 56.2451 75.2118 55.4408 75.2118 54.4487C75.2118 53.4566 74.4075 52.6523 73.4154 52.6523C72.4232 52.6523 71.6189 53.4566 71.6189 54.4487C71.6189 55.4408 72.4232 56.2451 73.4154 56.2451Z"
                    fill="url(#paint9_radial)"
                />
                <path
                    d="M80 17.3224C80 18.3145 79.1957 19.1188 78.2036 19.1188C77.2114 19.1188 76.4071 18.3145 76.4071 17.3224C76.4071 16.3303 77.2114 15.526 78.2036 15.526C79.1957 15.526 80 16.3303 80 17.3224Z"
                    fill="url(#paint10_radial)"
                />
                <path
                    d="M3.95121 28.6998C4.94336 28.6998 5.74765 27.8955 5.74765 26.9034C5.74765 25.9112 4.94336 25.107 3.95121 25.107C2.95907 25.107 2.15478 25.9112 2.15478 26.9034C2.15478 27.8955 2.95907 28.6998 3.95121 28.6998Z"
                    fill="url(#paint11_radial)"
                />
            </g>
            <defs>
                <radialGradient
                    id="paint0_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint1_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint2_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint3_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint4_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint5_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint6_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint7_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint8_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint9_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint10_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <radialGradient
                    id="paint11_radial"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(80 78.9999) rotate(-180) scale(80.243 146.061)">
                    <stop stopColor={from} />
                    <stop offset="1" stopColor={to} />
                </radialGradient>
                <clipPath id="clip0">
                    <rect width="80" height="80" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
